var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntityButtonCin7(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 182 55",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#002E6E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.32 8.261c8.297 0 12.958 5.02 14.033 11.421h-9.936c-.563-1.69-1.997-2.765-4.097-2.765-3.585 0-5.583 3.226-5.583 7.58 0 4.302 1.998 7.58 5.583 7.58 2.1 0 3.534-1.076 4.097-2.817h9.936c-1.075 6.453-5.736 11.472-14.033 11.472-9.168 0-15.57-6.811-15.57-16.235S74.152 8.26 83.32 8.26zM104.883 40.22h9.936V8.773h-9.936V40.22zM151.787 40.22h-8.143l-11.473-15.723V40.22h-9.577V8.773h9.27l10.346 14.648V8.773h9.577V40.22zM173.145 40.22h-9.988l8.195-22.996h-12.241v-8.45h22.843v6.401l-8.809 25.045z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.435 49.874l4.998 2.407 1.454.7L17.23 19.43h-5.743l6.949 30.444zM5.53 43.66l6.453 3.107-6.24-27.337H0l5.53 24.23zM32.315 35.2l-3.6-15.77h-5.742l6.47 28.35 2.872-12.58z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.114 49.053l-5.596 2.695L44.22 4.858l3.873 4.855-8.979 39.34zM50.312 43.66l-5.601 2.697 7.255-31.788 3.877 4.861-5.53 24.23zM15.495 0l-3.873 4.857h22.635l-1.109 4.858h-25.4l-3.874 4.857H32.04l-1.11 4.858H0l1.109 4.857h28.713l-6.389 27.994 4.488 2.161L40.348 0H15.495z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntityButtonCin7);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/entityButtonCin7.f27ab223.svg";
export { MemoForwardRef as ReactComponent };